<template>
  <div>
    <div v-show="!loading">
      <v-row style="min-height: 312px" >
        <v-col cols="12" class="pa-0 px-4">
          <div v-if="index === 0" style="height: 100%">
            <CertificacoesSelos
              @anexar="showModalAnexo = true"
            />
          </div>
          <div v-if="index === 1" style="height: 100%">
            <IniciativasInstitucionais
              ref="iniciativa"
              @anexar="showModalAnexo = true"
            />
          </div>
          <div v-if="index === 2" style="height: 100%">
            <PremiacoesMercado
              @anexar="showModalAnexo = true"
            />
          </div>
        </v-col>
      </v-row>
    </div>

    <modal-anexo
      :value="showModalAnexo"
      :aba="'Certificações'"
      @cancel="showModalAnexo = false"
      @reload-grid="showSuccess = true"
      v-if="showModalAnexo"
    />

    <SucessoModal
          :genericMessage="'Documento anexado com sucesso!'"
          :showSucess="showSuccess"
          successName='Documento anexado com sucesso!'
          @close="showSuccess = false"
    />
  </div>
</template>

<script>
import CertificacoesSelos from './CertificacaoSelo/CertificacoesSelos'
import IniciativasInstitucionais from './IniciativasInstitucionais'
import PremiacoesMercado from './PremiacoesMercado'

export default {
  components: {
    CertificacoesSelos,
    IniciativasInstitucionais,
    PremiacoesMercado
  },
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      show: false,
      loading: false,
      editavel: false,
      showSuccess: false,
      type: 'edit',
      error: false,
      errObj: {},
      message: 'editado com sucesso!',
      showModalAnexo: false,
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit'))
    }
  },
  computed: {
    getMessage () {
      return this.index === 0 ? 'Beneficiário ' + this.message : (this.index === 1 ? 'Cooperado ' + this.message : 'Colaborador ' + this.message)
    }
  },
  methods: {
    errorTeste (data) {

    },
    async validarMudanca () {
      await this.$refs.iniciativa.validarMudanca()
    },
    gerenciaComponente () {
      this.show = !this.show
    //   this.$refs.modalCompetencia.start()
    },
    salvaComponente (boolean) {
      if (!this.opcaoEditar) return true
      switch (this.index) {
        case 1:
          return this.$refs.iniciativa.handlerSalvar(boolean)
        default:
          return true
      }
    }
  }
}
</script>
